module.exports = __webpack_public_path__ + "static/HTH3-59c27b341a9eab6eea88a25b98adf8d0.png";